import React, { useState, useEffect } from "react";
import { IoArrowForwardOutline, IoMenuOutline, IoCloseOutline } from "react-icons/io5";
import "./App.css";
import { Link, useLocation } from "react-router-dom";

export default function HeaderHero() {
  const location = useLocation();
  const isHomePage = location.pathname === '/';
  const [isNavOpen, setIsNavOpen] = useState(false);

  const toggleNav = () => {
    setIsNavOpen(prev => !prev);
  };

  const closeNav = () => {
    setIsNavOpen(false);
  };

  useEffect(() => {
    if (isNavOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [isNavOpen]);

  // Close nav on route change
  useEffect(() => {
    closeNav();
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <>
      {/* Header */}
      <header className="header">
        <div className="container">
          <Link to="/" className="logo">
            <img src="./logovin.jpg" width="162" height="25" alt="VIN-Together Logo" />
          </Link>

          <nav className={`navbar ${isNavOpen ? 'active' : ''}`}>
            <div className="wrapper">
              <Link to="/" className="logo" onClick={closeNav}>
                <img src="./logovin.jpg" width="162" height="50" alt="VIN-Together Logo" />
              </Link>

              <button className="nav-close-btn" aria-label="close menu" onClick={toggleNav}>
                <IoCloseOutline aria-hidden="true" />
              </button>
            </div>

            <ul className="navbar-list">
              <li className="navbar-item">
                <a href="/" className="navbar-link" onClick={closeNav}>Home</a>
              </li>
              <li className="navbar-item">
                <Link to="/courses" className="navbar-link" onClick={closeNav}>Courses</Link>
              </li>
              <li className="navbar-item">
                <a href={isHomePage ? "#contribute" : "/#contribute"} className="navbar-link" onClick={closeNav}>Contribute</a>
              </li>
              <li className="navbar-item">
                <a href={isHomePage ? "#about" : "/#about"} className="navbar-link" onClick={closeNav}>About</a>
              </li>
              <li className="navbar-item">
                <a href={isHomePage ? "#footer_section" : "/#footer_section"} className="navbar-link" onClick={closeNav}>Contact</a>
              </li>
            </ul>
          </nav>

          <div className="header-actions">
            <a href={isHomePage ? "#footer_section" : "/#footer_section"} className="btn has-before">
              <span className="span">Leave a review!</span>
              <IoArrowForwardOutline aria-hidden="true" />
            </a>

            <button className="header-action-btn" aria-label="open menu" onClick={toggleNav}>
              <IoMenuOutline aria-hidden="true" />
            </button>
          </div>

          <div className={`overlay ${isNavOpen ? 'active' : ''}`} onClick={toggleNav}></div>
        </div>
      </header>

      {/* Hero Section */}
      {isHomePage && (
        <section 
          className="section hero has-bg-image" 
          id="home" 
          aria-label="home"
          /*style={{ backgroundImage: `url('./assets/images/hero-bg.svg')` }}*/
        >
          <div className="container">
            <div className="hero-content">
              <p className="hero-migration-badge">VInTogether is moving to SemGuru</p>
              <h1 className="h1 section-title">
                VIN Together <span className="span">One place Solution</span> for all your Exam Problems
              </h1>

              <p className="hero-text">
                We help you to ace your exams with the least efforts!!
              </p>

              <a href="#courses" className="btn has-before">
                <span className="span">Find courses</span>
                <IoArrowForwardOutline aria-hidden="true" />
              </a>
            </div>

            <figure className="hero-banner">
              <div className="img-holder one" style={{ width: 270, height: 300 }}>
                <img 
                  src="/conference-3677032_640.jpg" 
                  width="270" 
                  height="300" 
                  alt="hero banner" 
                  className="img-cover"
                />
              </div>

              <div className="img-holder two" style={{ width: 240, height: 370 }}>
                <img 
                  src="/WhatsApp Image 2025-02-18 at 20.44.02_872f8f49.jpg" 
                  width="240" 
                  height="370" 
                  alt="hero banner" 
                  className="img-cover"
                  />
              </div>
            </figure>
          </div>
        </section>
      )}
    </>
  );
}
